import service from '../service.js'

export default{

    searchLeaveRequest(search){
        return service.get('leave-request',
        {
            search : search
        })
    },

    getLeaveCoveredDate(leave_key){
        return service.get('leave-date',
        {
            leave_key : leave_key
        })
    },

    encodeLeaveRequest(leave_key){
        return service.post('encode-request',
        {
            leave_key : leave_key
        })
    },

    checkLeaveRequest(leave_key){
        return service.post('check-request',
        {
            leave_key : leave_key
        })
    },
}